import React from 'react'

import ErrorBoundary from "../../../error-boundary"
import MessageEditLeftPanel from "./form-left-panel"
import MessageEditRightPanel from "./form-right-panel"
import Message from "../../../model2/message/message"

type Props = {
    message     : Message

    onSubmit    : {(contentText: string, contentRTF: any, attachments: any):void}
    onCancel    : callback
}

export default function MessageEditMain(props:Props) {
    return (
        <React.Fragment>
            <ErrorBoundary>
                <MessageEditLeftPanel message    ={props.message}/>
            </ErrorBoundary>

            <ErrorBoundary>
                <MessageEditRightPanel message  = {props.message}
                                       onSubmit = {props.onSubmit}
                                       onCancel = {props.onCancel}/>
            </ErrorBoundary>
        </React.Fragment>
    )

}